var map = {
	"./address_image.svg": 128,
	"./animated_logo.svg": 129,
	"./blogs_image.svg": 130,
	"./cloud_infrastructure.svg": 131,
	"./codeInLogo.png": 132,
	"./contactMail.png": 133,
	"./coursera_logo.png": 134,
	"./data_science.svg": 135,
	"./deeplearning_ai_logo.png": 136,
	"./delhivery_logo.png": 137,
	"./developerActivity.svg": 138,
	"./dsc_logo.png": 139,
	"./education.svg": 140,
	"./experience.svg": 141,
	"./feelingProud.svg": 142,
	"./freecopy_logo.png": 143,
	"./fullstack.svg": 144,
	"./gcp_logo.png": 145,
	"./github_logo.png": 146,
	"./googleAssistant.jpg": 147,
	"./googleAssistant.svg": 148,
	"./google_logo.png": 149,
	"./ibm_logo.png": 150,
	"./iiitk_logo.png": 151,
	"./intel_logo.jpg": 152,
	"./iu_logo.png": 153,
	"./jsFramework.svg": 154,
	"./legato_logo.png": 155,
	"./manOnTable.svg": 156,
	"./microsoft_logo.png": 157,
	"./mozilla_logo.png": 158,
	"./muffito_logo.png": 159,
	"./my_image.jpg": 160,
	"./nextuLogo.jpg": 161,
	"./nptel_logo.png": 162,
	"./portfolio.gif": 163,
	"./programmer.svg": 164,
	"./projects_image.svg": 165,
	"./pwa.png": 166,
	"./saayaHealthLogo.png": 167,
	"./stanford_logo.png": 168,
	"./talksCardBack.svg": 169,
	"./talksCardBackAlt.svg": 170,
	"./tiktok_logo.png": 171,
	"./ui_ux_design.svg": 172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;